export default __webpack_public_path__ + "static/liveshare-81c5ce674270875edc38444e6e55ec15.png";